import { useAppSelector } from 'src/store/store';

import ImportJobModal from 'src/sections/jobs/modals/import-job-modal';
import JobApprovalModal from 'src/sections/jobs/modals/job-approval-modal';
import JobLinkActionModal from 'src/sections/jobs/modals/job-link-action-modal';
import CandidateJobActionModal from 'src/sections/jobs/modals/candidate-job-action-modal';
import CandidateJobRequestsModal from 'src/sections/jobs/modals/candidate-job-requests-modal';
import PendingCandidateInviteModal from 'src/sections/jobs/modals/pending-candidate-invite-modal';
import ConnectionActionModal from 'src/sections/connections/modal/connection-action-modal/connection-action-modal';
import CreateConnectionModal from 'src/sections/connections/modal/create-connection-modal/create-connection-modal';

export default function ModalContainer() {
  const showConnectionActionModal = useAppSelector(
    (state) => state.connectionsState.showConnectionModal
  );

  const showCreateConnectionModal = useAppSelector(
    (state) => state.connectionsState.showCreateConnectionModal
  );

  const showJobLinkActionModal = useAppSelector((state) => state.jobs.showJobLinkActionModal);

  const showJobVerificationModal = useAppSelector((state) => state.jobs.showJobVerificationModal);

  const showCandidateJobRequestsModal = useAppSelector(
    (state) => state.jobs.showCandidateJobRequestsModal
  );

  const showCandidateInviteActionModal = useAppSelector(
    (state) => state.jobs.showCandidateInviteActionModal
  );

  const showPendingCandidateInvitesModal = useAppSelector(
    (state) => state.jobs.showPendingCandidateInvitesModal
  );

  const showImportJobModal = useAppSelector((state) => state.jobs.showImportJobModal);

  return (
    <>
      <ConnectionActionModal open={showConnectionActionModal} />

      <CreateConnectionModal open={showCreateConnectionModal} />

      <JobLinkActionModal open={showJobLinkActionModal} />

      <JobApprovalModal open={showJobVerificationModal} />

      <CandidateJobRequestsModal open={showCandidateJobRequestsModal} />

      {showCandidateInviteActionModal && (
        <CandidateJobActionModal open={showCandidateInviteActionModal} />
      )}

      <PendingCandidateInviteModal open={showPendingCandidateInvitesModal} />

      <ImportJobModal open={showImportJobModal} />
    </>
  );
}
